import {gemStore} from 'app/gemStore';

import type {ScrollDeeplinkItem} from './types';

export const addScrollDeeplinkItemAction = (item: ScrollDeeplinkItem) => gemStore.getState().addScrollDeeplinkItem(item);
export const removeScrollDeeplinkItemAction = (cId: string) => gemStore.getState().removeScrollDeeplinkItem(cId);
